import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/logo.svg';
import { Menu, X } from 'lucide-react'; // Requires lucide-react

const Header = ({ darkMode, toggleDarkMode }) => {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const navItems = [
    { name: "About", path: "/About" },
    { name: "JSON Validator", path: "/" },
    { name: "JSON to YAML", path: "/json-to-yaml" },
    { name: "YAML to JSON", path: "/yaml-to-json" },
    { name: "JSON to XML", path: "/json-to-xml" },
    { name: "XML to JSON", path: "/xml-to-json"}
  ];

  const toggleMenu = () => setMenuOpen(!menuOpen);

  return (
    <header className="w-full border-b border-gray-300 dark:border-gray-700 bg-white dark:bg-zinc-900 shadow-sm">
      <div className="max-w-7xl mx-auto px-4 py-4 flex justify-between items-center">
        {/* Left: Logo */}
        <div className="flex items-center gap-4">
          <img src={logo} alt="Logo" className="h-8 w-auto" />
          <Link
            to="/"
            className="text-xl font-extrabold bg-gradient-to-r from-blue-500 to-purple-500 text-transparent bg-clip-text tracking-tight"
          >
            Incognito JSON Tools
          </Link>
        </div>

        {/* Desktop nav */}
        <nav className="hidden sm:flex gap-3 items-center">
          {navItems.map(({ name, path }) => (
            <Link
              key={path}
              to={path}
              className={`text-sm font-medium px-3 py-1 rounded-lg transition-colors duration-200 ${
                location.pathname === path
                  ? "bg-blue-600 text-white dark:bg-blue-500"
                  : "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200"
              }`}
            >
              {name}
            </Link>
          ))}
          <button
            onClick={toggleDarkMode}
            title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            aria-label={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            className="ml-2 bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600 text-black dark:text-white p-2 rounded-full shadow transition-colors"
          >
            {darkMode ? "🌞" : "🌙"}
          </button>
        </nav>

        {/* Mobile menu toggle */}
        <div className="sm:hidden flex items-center gap-2">
          <button 
            onClick={toggleDarkMode} 
            className="text-2xl"
            title={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
            aria-label={darkMode ? "Switch to Light Mode" : "Switch to Dark Mode"}
          >
            {darkMode ? "🌞" : "🌙"}
          </button>
          <button 
            onClick={toggleMenu} 
            className="p-2 rounded-md text-gray-700 dark:text-white"
            aria-label={menuOpen ? "Close menu" : "Open menu"}
            aria-expanded={menuOpen}
          >
            {menuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {menuOpen && (
        <div className="sm:hidden px-4 pb-4">
          {navItems.map(({ name, path }) => (
            <Link
              key={path}
              to={path}
              onClick={() => setMenuOpen(false)}
              className={`block text-sm font-medium px-3 py-2 rounded-lg transition-colors duration-200 ${
                location.pathname === path
                  ? "bg-blue-600 text-white dark:bg-blue-500"
                  : "hover:bg-gray-100 dark:hover:bg-gray-800 text-gray-700 dark:text-gray-200"
              }`}
            >
              {name}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
};

export default Header;
